import { useQuery } from 'react-query';
import api from '../utils/api';

const searchSongs = async (query, musicService, sessionId) => {
  if (!query || !musicService) {
    return [];
  }

  console.log('[useSongSearch] Searching songs:', { query, musicService, sessionId });

  const params = {
    query,
    musicService,
    limit: 20
  };

  // Spotify search requires sessionId so the server can look up the host's token
  if (musicService === 'spotify' && sessionId) {
    params.sessionId = sessionId;
  }

  const response = await api.get('/api/playlist/search', { params });

  console.log('[useSongSearch] Search response:', response.data);
  return response.data.results || [];
};

export const useSongSearch = (query, musicService, enabled = true, sessionId = null) => {
  return useQuery(
    ['songSearch', query, musicService, sessionId],
    () => searchSongs(query, musicService, sessionId),
    {
      enabled: enabled && !!query && !!musicService,
      staleTime: 5 * 60 * 1000, // 5 minutes
      cacheTime: 10 * 60 * 1000, // 10 minutes
      retry: 1,
      onError: (error) => {
        console.error('Song search error:', error);
      }
    }
  );
}; 